import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, map, tap} from 'rxjs/operators';
import {of} from 'rxjs';
import {Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';

import * as CreateOrganizationActions from '../actions/create-organization.actions';
import {OrganizationsService} from '../../../services/api/organizations/organizations.service';
import {ManageOrganization, Organization} from '../../../services/api/organizations/models/organization.model';


@Injectable()
export class CreateOrganizationEffects {

  // noinspection JSUnusedGlobalSymbols
  createOrganization$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CreateOrganizationActions.createOrganization),
      concatMap((payload: { data: ManageOrganization }) =>
        this.organizationsService.createOrganization(payload.data)
          .pipe(
            map((data: Organization) => CreateOrganizationActions.createOrganizationSuccess({data})),
            catchError((error: unknown) => of(CreateOrganizationActions.createOrganizationFailure({error})))
          )
      )
    );
  });

  // noinspection JSUnusedGlobalSymbols
  createOrganizationSuccess$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(CreateOrganizationActions.createOrganizationSuccess),
      tap(() => this.snackBar.open('Organization successfully created', 'Success', {duration: 3000})),
      tap(() => this.router.navigate(['/organizations']))
    );
  }, {dispatch: false});


  constructor(
    private readonly actions$: Actions,
    private readonly organizationsService: OrganizationsService,
    private readonly snackBar: MatSnackBar,
    private readonly router: Router
  ) {
  }

}
